import FlipBoard from './FlipBoard';

export default FlipBoard;
